import * as React from "react"

import t from "@/constants/wording"
import { Layout, Seo } from "@/components"
import { HeaderBar } from "@/components/header-bar/simpale-detail-header-bar"
import Content from "@/components/detail/content"
import Pagination from "@/components/detail/pagination"
import MarkdownToText from "@/components/markdown-to-text"

const CompanyNewsDetail: React.FC<CompanyNewsPage & { myLocation: ILocation }> = ({
  pageContext,
  location,
  myLocation,
}) => {
  const { prev, next, companyNewsDetail } = pageContext

  const { title, body } = companyNewsDetail

  const seoProps = {
    title,
    description: MarkdownToText(body, 150),
    keywords: t("keywords"),
  }

  return (
    <Layout>
      <Seo {...seoProps} />
      <HeaderBar title={title} />
      <Content {...companyNewsDetail} {...location} myLocation={myLocation} />
      {(prev || next) && <Pagination prev={prev} next={next} />}
    </Layout>
  )
}

export default CompanyNewsDetail
